export const BOAT_QUERY = `
query (
  $id: ID!
  $i18nLanguage: String
)
@i18n(
  language: $i18nLanguage
) {
  boat (
    id: $id
  ) {
    id
    company {
      id
      name
    }
    corkageInCents
    corkagePerPersonInCents
    corkageType
    description {
      value
    }
    includedItems {
      id
      name {
        value
      }
    }
    image {
      url
    }
    name
    minGroupSize
    pricePerHourInCents
    pricePerPersonInCents
    pricingType
    products {
      id
      isDefault
      description {
        value
      }
      forAmountOfPeople
      foodPricingType
      name {
        value
      }
      pricePerPersonInCents
      priceInCents
      type
    }
    surcharges {
      id
      name
      surchargeInCents
      surchargePricingType
    }
    tripDurations {
      id
      isDefault
      durationInSeconds
      name
      pricePerPersonInCents
    }
  }
}
`

export const BOAT_LIST_QUERY = `
query (
  $i18nLanguage: String
  $filters: [FilterInput]
) @i18n (
  language: $i18nLanguage
) {
  boatList (
    filters: $filters
  ) {
    id
    name
    company {
      name
    }
  }
}
`

export const BOATS_QUERY = `
query (
  $filters: [FilterInput]
  $i18nLanguage: String
  $pageNumber: Int
  $pageSize: Int
  $sorting: [SortingInput]
)
@i18n (
  language: $i18nLanguage
) {
  boats (
    filters: $filters
    pageNumber: $pageNumber
    pageSize: $pageSize
    sorting: $sorting
  ) {
    data {
      id
      company {
        name
      }
      description {
        value
      }
      name
      minGroupSize
      pricePerHourInCents
      pricePerPersonInCents
      createdAt
      updatedAt
    }
    total
  }
}
`
